import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const MAY_MEMBERS_2025_CAMPAIGN_END_DATE = d(2025, 5, 12, 12, 0);
